import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import PageHeader from '../components/PageHeader';
import api from '../services/api';
import './ProgramsList.scss';

const FALLBACK_PROGRAMS = [
  {
    slug: 'code',
    title: 'CODE',
    subtitle: 'Mindset & Performance',
    description: "Programme intensif de transformation du mindset destiné aux jeunes étudiants universitaires ambitieux à fort potentiel.",
    frequency: 'Tous les 2 mois',
    format: 'En ligne',
    color: '#3B5BA5',
  },
  {
    slug: 'trajectoire',
    title: 'TRAJECTOIRE',
    subtitle: 'Orientation & Compétence',
    description: "Programme structuré qui aide les jeunes étudiants à clarifier leur orientation académique et construire une stratégie de carrière.",
    frequency: '1 filière/an',
    format: 'Hybride',
    color: '#E8731A',
  },
  {
    slug: 'propel',
    title: 'PROPEL',
    subtitle: "Programme d'Intégration et d'Excellence Professionnelle",
    description: "Formation intensive destinée aux étudiants ayant obtenu leur BTS, Licence et Master pour une intégration professionnelle réussie.",
    frequency: '3 jours intensifs',
    format: 'Présentiel + Stage',
    color: '#D63070',
  },
];

const ProgramsList = () => {
  const [programs, setPrograms] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/programs')
      .then(({ data }) => setPrograms(data.data || FALLBACK_PROGRAMS))
      .catch(() => setPrograms(FALLBACK_PROGRAMS))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="programs-list-page">
      <PageHeader 
        title="Nos Programmes" 
        subtitle="Des parcours adaptés à vos ambitions"
        breadcrumb={['Accueil', 'Programmes']}
        image="/assets/IMG/Header_Nos_Programmes.jpg"
        hideText={true}
      />

      <div className="programs-list-container">
        <div className="programs-intro">
          <p>
            La Fondation BE TALENTED concentre ses actions autour de trois axes majeurs, 
            chacun incarné par un programme structuré et opérationnel.
          </p>
        </div>

        {loading && (
          <div className="programs-loading">
            {[1, 2, 3].map((n) => (
              <div key={n} className="program-card-skeleton" />
            ))}
          </div>
        )}

        <div className="programs-grid">
          {programs.map((program) => (
            <Link 
              key={program.slug} 
              to={`/programmes/${program.slug}`} 
              className="program-card-link"
            >
              <div className="program-card" style={{ '--card-color': program.color }}>
                <div className="program-header" style={{ background: program.color }}>
                  <h2>{program.title}</h2>
                  <p className="program-subtitle">{program.subtitle}</p>
                </div>
                <div className="program-body">
                  <p className="program-description">{program.description}</p>
                  <div className="program-meta">
                    <div className="meta-item">
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5">
                        <circle cx="10" cy="10" r="8"/>
                        <path d="M10 5 L10 10 L14 14"/>
                      </svg>
                      <span>{program.frequency}</span>
                    </div>
                    <div className="meta-item">
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5">
                        <rect x="4" y="5" width="12" height="11" rx="1"/>
                        <path d="M7 3 L7 5"/>
                        <path d="M13 3 L13 5"/>
                      </svg>
                      <span>{program.format}</span>
                    </div>
                  </div>
                  <button className="view-details-btn" style={{ background: program.color }}>
                    Voir les détails
                  </button>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProgramsList;
